module.exports = __webpack_public_path__ + "img/6.c427df17.png";